/* eslint-disable */
require('./body')
require('./brain')
require('./career')
require('./knowledge')
require('./leisure')
require('./mind')
require('./soul')
